export default function Navlink( props ) {
    return (
        <button onClick={() => {window.location.href=props.location}} className="dark:text-white font-semibold">
            {props.children}
        </button>
    )
}